import { Box, Typography } from '@mui/material';
import { CallList } from '@/components';
import PageHeader from '@/components/common/PageHeader';

/**
 * Calls listing page.
 */

const CallsPage: React.FC = () => {
    return (
        <Box>
            <PageHeader>
                <Typography variant="h2" component="h1">
                    Calls
                </Typography>
            </PageHeader>
            <Box p={2}>
                <CallList />
            </Box>
        </Box>
    );
};

export default CallsPage;
